const pageDesign = r => require.ensure([], () => r(require('../../views/pageDesign/index.vue')), 'pageDesign')

export default [
  {
    path: '/',
    name: 'pageDesign',
    component: pageDesign
  }
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/pageDesign.js